import { create } from 'fedops-logger';

const NAME = '';

const mocked = {
  appLoadStarted: () => ({}),
  appLoaded: () => ({}),
  interactionStarted: (name: string) => ({}),
  interactionEnded: (name: string) => ({}),
};

class Logger {
  name: 'cashier-payments-widget';

  fedopsLogger: {
    appLoadStarted: () => any,
    appLoaded: () => any,
    interactionStarted: (name: string) => any,
    interactionEnded: (name: string) => any,
  };

  constructor() {
    this.fedopsLogger = create(this.name, {baseUrl: null, isWidgetLogger: true}) || mocked;
    this.appLoadStarted();
  }

  interactionStarted = (name: string) => this.fedopsLogger.interactionStarted(name);
  interactionEnded = (name: string) => this.fedopsLogger.interactionEnded(name);

  appLoaded = () => this.fedopsLogger.appLoaded();
  appLoadStarted = () => this.fedopsLogger.appLoadStarted();
}

export default Logger;



// WEBPACK FOOTER //
// ./utils/logger.ts